import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import { clerkLocalization } from "@championcare/ui";
import "@championcare/ui/styles.css";
import "./styles.css";
import "./design-tokens.css";
import { App } from "./App";
import { CLERK_ENABLED, CLERK_PUBLISHABLE_KEY } from "./config";
import { initObservability } from "./observability";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

void initObservability(); // Sentry (PHI-scrubbed, PII off) — no-op without a DSN

// Mount Clerk only when a publishable key is configured, so the signup page can render the real
// <SignUp>. Without a key the public site still renders (the signup page falls back to a hand-off
// link) — keeps the build working in keyless environments.
function Root({ children }: { children: ReactNode }) {
  return CLERK_ENABLED ? (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY} localization={clerkLocalization}>
      {children}
    </ClerkProvider>
  ) : (
    <>{children}</>
  );
}

createRoot(root).render(
  <StrictMode>
    <Root>
      <App />
    </Root>
  </StrictMode>,
);
